import React from 'react';
import HomePage from './Homepage';
import Footer from './Footer';
import './App.css';

function App() {
  return (
    <>
    <div className="App">
        <HomePage/>
    </div>
    <Footer/>
    </>
  );
}

export default App;
